import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'td-wb-confirm-body',
  template: '<ng-content />',
  styleUrls: ['confirm-body.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmBodyComponent {}
